@if (data) {
  <div class="flow-row">
    <div>
      @if (imageSrc) {
        <img [src]="imageSrc" />
      }
    </div>
    <div class="flow-column">
      <div>{{ data.lastFour }}</div>
      <div>{{ data.expiryDate }}</div>
      <div>{{ data.playerName }}</div>
    </div>
  </div>
}
